import { CreditInsurance } from './credit-insurance';
import {Model} from './model';
import {Unserializer} from './serialization';

export class EndCustomer implements Model {
  endCustomerId: number;
  businessId: string;
  vatNumber: string;
  name: string;
  department: string;
  street: string;
  zip: string;
  city: string;
  country: string;
  eInvoiceOperator: string;
  eInvoiceAddress: string;
  creditLimit?: number;
  limitUpdated?: Date;
  discount?: number;
  creditInsurances: Array<CreditInsurance>

  static copy(oldObj: EndCustomer): EndCustomer {
    const newObj = new EndCustomer();
    newObj.endCustomerId = oldObj.endCustomerId;
    newObj.businessId = oldObj.businessId;
    newObj.vatNumber = oldObj.vatNumber;
    newObj.name = oldObj.name;
    newObj.department = oldObj.department;
    newObj.street = oldObj.street;
    newObj.zip = oldObj.zip;
    newObj.city = oldObj.city;
    newObj.country = oldObj.country;
    newObj.eInvoiceOperator = oldObj.eInvoiceOperator;
    newObj.eInvoiceAddress = oldObj.eInvoiceAddress;
    newObj.creditLimit = oldObj.creditLimit;
    newObj.limitUpdated = Unserializer.date(oldObj.limitUpdated);
    newObj.discount = oldObj.discount;
    newObj.creditInsurances = oldObj.creditInsurances;
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.endCustomerId;
  }

  isNew(): boolean {
    return isNaN(this.endCustomerId);
  }

  clone(): EndCustomer {
    return EndCustomer.copy(this);
  }
}
